/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

console.log('🪪 ' + VERSION)
console.log('🪪 ' + BUILD_TIMESTAMP)
console.log('🪪 ' + ENVIRONMENT)


// Components
import App from './App.vue'
// import router from './router';
import * as Sentry from "@sentry/vue";



// import "vue3-openlayers/styles.css"; //

// Composables
import { createApp } from 'vue'


// Custom Directives
// import clickSound from '@/directives/v-click-sound.js'

// Plugins
import { registerPlugins } from '@/plugins'

// import './registerServiceWorker'
import installI18n from './lang/index'


import figlet from "figlet";
import standard from "figlet/importable-fonts/Standard.js";


figlet.parseFont("Standard", standard)

figlet.text(
  "PNGP - Picker",
  {
    font: "Standard",
    horizontalLayout: "default",
    verticalLayout: "default",
    width: 80,
    whitespaceBreak: true,
  },
  function (err, data) {
    if (err) {
      console.log("Something went wrong...")
      console.dir(err)
      return;
    }
    console.log(data)
  }
)




const app = createApp(App)

// nel vite config vengono definite,
// qui vengono rese disponibili come global properties
app.config.globalProperties.ENVIRONMENT = ENVIRONMENT
app.config.globalProperties.VERSION = VERSION
app.config.globalProperties.BUILD_TIMESTAMP = BUILD_TIMESTAMP


const dev_location = 'picker.localhost'

switch (ENVIRONMENT) {

  case 'production':
    break;

  case 'staging':
    break;

  case 'development':
    if (window.location.hostname != dev_location) {
      // window.location.hostname = dev_location
    }

    break;
}


if (ENVIRONMENT !== 'development') {

  console.log('🦸‍♂️ Sentry init')

  Sentry.init({   // glitchtip
    app,
    dsn: "https://852ff3880fae5caa829bcdc47abdc23b@o4507627658215424.ingest.de.sentry.io/4507627813404752",
    ignoreErrors: [
      "Failed to update a ServiceWorker for scope "
    ],
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    transportOptions: {},
    tracesSampleRate: 0.02,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: ENVIRONMENT,
    release: VERSION
  });

  // Sentry.init({          // sentry.io
  //   app,
  //   dsn: "https://852ff3880fae5caa829bcdc47abdc23b@o4507627658215424.ingest.de.sentry.io/4507627813404752",
  //   ignoreErrors: [
  //     "Failed to update a ServiceWorker for scope "
  //   ],
  //   integrations: [
  //     Sentry.browserTracingIntegration(),
  //     // new Sentry.BrowserTracing({
  //     //   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  //     //   // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  //     // }),
  //     // new Sentry.Replay({
  //     //   maskAllText: false,
  //     //   blockAllMedia: false,
  //     // }),

  //     // Sentry.replayIntegration({
  //     //   // Additional SDK configuration goes in here, for example:
  //     //   maskAllText: true,
  //     //   blockAllMedia: true,
  //     // }),

  //   ],
  //   transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  //   transportOptions:{},
  //   // Performance Monitoring
  //   // tracesSampleRate: 1.0, //  Capture 100% of the transactions
  //   tracesSampleRate: 0.02, //  Capture 2% of the transactions
  //   // Session Replay
  //   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  //   environment: ENVIRONMENT,
  //   release: VERSION
  // });

}
else {
  console.log(`🦸‍♂️ Sentry disabled in ${ENVIRONMENT} environment`)
}
















registerPlugins(app)

installI18n(app)

app.mount('#app')

